import { ALPHABET_LETTERS_REGEX, ALPHABET_NUMBERS_CHARS_REGEX, EMAIL_REGEX } from '../../utils/constants';

export function getEditedContactData(contact) {
  const phones = contact.phones.map(phone => phone.value);
  const phonesMetadata = contact.phones.map(phone => ({
    isEdited: phone.isEdited,
    isManuallyAdded: phone.isManuallyAdded,
    type: phone.type,
  }));
  const emails = contact.emails.map(email => email.value);
  const emailsMetadata = contact.emails.map(email => ({
    isEdited: email.isEdited,
    isManuallyAdded: email.isManuallyAdded,
    label: email.type.toLowerCase(),
  }));

  return {
    emails,
    emailsMetadata,
    phones,
    phonesMetadata,
  };
}

export const validateEmail = email => EMAIL_REGEX.test(String(email).toLowerCase());

export const validateLetters = input => ALPHABET_LETTERS_REGEX.test(String(input).toLowerCase());

export const validateAlphabetLettersCharsNumbers = input => ALPHABET_NUMBERS_CHARS_REGEX.test(String(input).toLowerCase());
